import { render, staticRenderFns } from "./ListadoAccionesNuevas.vue?vue&type=template&id=180b9df2&scoped=true"
import script from "./ListadoAccionesNuevas.vue?vue&type=script&lang=js"
export * from "./ListadoAccionesNuevas.vue?vue&type=script&lang=js"
import style0 from "./ListadoAccionesNuevas.vue?vue&type=style&index=0&id=180b9df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b9df2",
  null
  
)

export default component.exports